<template>
  <div class="WalletCenter">
    <div style="height:1.8rem;" >
        <div class="wrap-info">
            <div class="wrap-info-header">
                <span class="user-pic icon-w-pic"></span><span class="user-phone">{{ wallet.wallet_name }}</span>
            </div>
            <div class="wrap-info-flex">
                <div class="flex-box">
                    <p>
                        <span>¥</span>
                        <span class="balance">{{ wallet.balance || '0' }}</span>
                    </p>
                    <p>账户余额</p>
                </div>
                <div class="flex-box" v-if="wallet.drawable_off == 1">
                    <p>
                        <span>¥</span>
                        <span class="balance">{{ wallet.drawable_bal || '0' }}</span>
                    </p>
                    <p>
                        <span>可提现余额</span>
                        <span class="icon-w-question" @click="showWithdrawHint"></span>
                    </p>
                </div>
            </div>
        </div>
    </div>
    
    <div :class="{ 'no-padding': wallet.drawable_off == 2 && wallet.recharge_off == 2 , 'wrap-info-flex': true, 'wrap-info-flex-white': true }">
        <div class="flex-box" v-if="wallet.recharge_off == 1"> <a href="javascript:;" @click="toRecharge">充值</a></div> 
        <div class="flex-box" v-if="wallet.drawable_off == 1"><a href="javascript:;" @click="toWithdraw">提现</a></div>
    </div>

    <div class="list margin-tp-md">
        <a href="javascript:;" class="item item-md" @click="toBankCards">
            <span class="list-icon">
                <i class="icon-w-card"></i>
            </span> 我的银行卡
                        
            <span class="el-rt fz-num">
                <span class="color-theme">{{ card_nums }}张</span>
                <i class="icon-arrow-rt"></i>
            </span>
        </a>

        <a href="javascript:;" class="item item-md" @click="toRecord">
            <span class="list-icon">
                <i class="icon-w-extract"></i>
            </span> 
             交易记录
            <span class="el-rt fz-num">
                <i class="icon-arrow-rt"></i>
            </span>
        </a>
    </div>

    <div class="list margin-tp-md">
        <a href="javascript:;" class="item item-md" @click="toSetting">
            <span class="list-icon">
                <i class="icon-w-setting"></i>
            </span> 设置
                        
            <span class="el-rt">
                <i class="icon-arrow-rt"></i>
            </span>
        </a>
    </div>
    <!-- <footer class="copyright">富力钱包由腾讯牵头发起设立的微众银行提供技术支持</footer> -->
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import {Get,Post} from '@/utils/http';
import { Toast } from 'mint-ui';
import { MessageBox } from 'mint-ui';
export default {
  name: 'WalletCenter',
  data () {
    return {
        cardIndex:      0,
        wallet:         {
            bank_cards:     0,
            drawable_off:   2,
            recharge_off:   2,
        },
    }
  },
  computed: {
    // 钱包银行卡数量
    card_nums () {
        return this.wallet.bank_cards || 0;
    },
  },
  methods: {

    //切换钱包
    handleChange(index) {
       this.cardIndex = index;
    },

    // 设置钱包密码
    setPassword(){
        const url = '/v1/person/wallet/password/set';
        const params = {
            redirect:   window.location.href
        }
        Indicator.open();
        Post(url,params).then((res)=>{
            Indicator.close();
            window.location = res.pwd_set_url;
        }).catch((error)=>{
            Toast({
                    message: "code:"+error.code+" message:"+error.msg,
                    duration: 3000
                });
        })
    },

    // 重置钱包密码
    resetPassword(){
        const url = '/v1/person/wallet/password/reset';
        const params = {
            redirect:   window.location.href
        }
        Indicator.open();
        Post(url,params).then((res)=>{
            Indicator.close();
            window.location = res.pwd_reset_url;
        }).catch((error)=>{
            Toast({
                    message: "code:"+error.code+" message:"+error.msg,
                    duration: 3000
                });
        })
    },

    // 提示绑定银行卡
    showBindCardHint(message){
        MessageBox({
          title: '',
          message: message,
        //   showCancelButton: true,
          showConfirmButton:true,
          confirmButtonText:'立即绑定'
        }).then(action => {
             if(action == 'confirm'){
                this.bindCard();
            }
        })
    },

    // 设置密码提示
    showSetPasswordHint(){
        MessageBox({
          title: '',
          message: '您还未设置钱包密码',
        //   showCancelButton: true,
          showConfirmButton:true,
          confirmButtonText:'立即设置'
        }).then(action => {
            if (action == 'confirm') {
                this.setPassword();
            }
        })
    },

    // 钱包已锁定提示
    showUnlockHint () {
        MessageBox({
          title: '',
          message: '您的钱包已被锁定',
        //   showCancelButton: true,
          showConfirmButton:true,
          confirmButtonText:'立即解锁'
        }).then(action => {
            if (action == 'confirm') {
                this.resetPassword();
            }
        })
    },

    // 开通钱包提示
    showWalletHint(){
        MessageBox({
          title: '',
          message: '您还未开通富力金融平台帐号，请先开通后再使用',
        //   showCancelButton: true,
          showConfirmButton:true,
          confirmButtonText:'立即开通'
        });
    },

    // 我的银行卡
    toBankCards(){
        if(this.wallet.pwd_status !== 1){
           this.showSetPasswordHint();
           return;
        }
        this.$router.push({ name: 'BankCards' })
    },

    // 充值
    toRecharge(){
        if(this.wallet.pwd_status !== 1){
           this.showSetPasswordHint();
           return;
        }
        if(this.card_nums === 0){
          this.showBindCardHint('您还未绑定银行卡，无法充值');
          return;
        }
        this.$router.push({ name: 'Recharge'})
    },

    // 提现
    toWithdraw(){
        if(this.wallet.pwd_status !== 1){
           this.showSetPasswordHint();
           return;
        }
        if(this.card_nums == 0){
          this.showBindCardHint('您还未绑定银行卡，无法提现');
          return;
        }
        this.$router.push({ name: 'Withdraw' })
    },


    // 设置页面
    toSetting(){
    //    if(this.wallet.pwd_status !== 1){
    //       this.showSetPasswordHint();
    //       return;
    //    }
        this.$router.push({ name: 'Setting' })
    },
   
    // 交易记录
    toRecord(){
        if(this.wallet.pwd_status !== 1){
           this.showSetPasswordHint();
           return;
        }
        if(this.card_nums == 0){
          this.showBindCardHint('您还未绑定银行卡，无法查看记录');
          return;
        }
        this.$router.push({ name: 'Record' })
    },

    // 获取钱包
    getWallet () {
        const url = '/v1/person/wallet/info';
        const params = {};

        Indicator.open();
        Post(url, params).then((res)=>{
            this.wallet = res;
            Indicator.close();

            if(this.wallet.pwd_status !== 1) {
                this.showSetPasswordHint();
            }
        }).catch((/* error */ { code, msg })=>{
            // const code = error.code;
            // const msg = error.msg;
            Indicator.close();
            if (code === 28115) {
                this.showSetPasswordHint();
            } else if (code === 28100) {
                this.$router.replace('/login');
            } else if (code === 28101) {
                this.$router.replace('/createGateWay');
            } else if (code === 28114) {
                this.showUnlockHint();
            } else if (code === 28126) {
                this.showSetPasswordHint();
            } else {
                Toast({
                    message:    `${code}：${msg}`,
                    duration: 3000
                });
                // console.error(error);
                // alert(JSON.stringify(error));
                // Toast({
                //     message:    `${JSON.stringify(error)}`,
                //     duration: 3000
                // });
            }
        })
    },

    // 绑定银行卡
    bindCard(){
       const url = '/v1/person/wallet/card/bind';
       const params = {
           redirect:    window.location.href
       }
       Indicator.open();
       Post(url,params).then((res)=>{
           Indicator.close();
           window.location = res.bank_card_bind_url;
       }).catch((error)=>{
          Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
       })
    },

    // 点击问号提示
    showWithdrawHint(){
        MessageBox({
          title: '',
          message: '当天充值金额在下一个工作日可以提现',
          showConfirmButton:true,
          confirmButtonText:'知道了'
        });
    },
  },
  mounted () {
    this.getWallet();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.WalletCenter{
  text-align: left;
    .wrap-info {
        width: 100%;
        height: 1.8rem;
        background: #3b8aff;
        padding: .15rem;
        color: #fff;
        .wrap-info-header {
            line-height: 0;
        }
        .user-phone {
            display: inline-block;
            height: .32rem;
            line-height: .32rem;
            margin-left: 5px;
        }
        .user-pic {
             width: .32rem;
            height: .32rem;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            -o-border-radius: 50%;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: middle;
        }
        .icon-w-question {
            vertical-align: middle;
            margin-top: -1px;
        }

    }
}
.icon-w-pic {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABmUExURUxpcfPz8/X19fj4+O/v7/Pz8/b29uzs7Pb29vj4+PHx8fj4+PHx8fDw8PT09P////Pz8/X19fj4+O7u7szMzPX19e7u7vf398fHx+jo6PPz883Nzd7e3tHR0dTU1NnZ2eTk5MrKyhc91vgAAAAWdFJOUwBhjezsfzf+/g/HG9FU3wNzq9SljiqQMu7+AAACuUlEQVRYw51X2ZasIAx0h3Zr7ZmDscGF///Ji2hPowTFW48eUiZQKUgQOFBUaVvWMaVxXbZpVQS3kEWv7oBXlPlGPxoreuNoHj7hadw5EaeXFOFJuKYIT8OLvLtEfrKfWdx5IHbuZkg7L1C8jGfUeSN6IvFtdwOtzRB1txBZ9Xc3cdiH7H2XgO7OokgYu0sRm3rI2QJ6jyE3NoCteNP/24ZHwj64VUf86ayUGbiTRGolcLOOLYWGHfBXBxEDl3wUzMXQaIKSMZSi5/DB6KB4aQ0xDJROAFyQ9/vdTxJA4AyLmiKUgHCQ82fZWwBMzpYoUYIBODEW9hLPQdXwQOMnkGSnCgJAMIYiqNACJMwHVQgYMIJqr6JvAuNRFZSjKaTBD0bAtwRMVQh0H9utEffoQdrCYsARgjKoEYIZhoMqlrUAiMjrIEEIxN8WmA3CAenVOCBeBEsdEiOgKIFVggYAZo1oCYtqMFaKlVDjQhbWtxEmxLBq9BjVJnD7aKFHPK/EhaSUNFlJTZjntbiUVcGHItbusj0vxZtpKcJkICMY4jbrqBztrBn4FkOEVO6C22bhMhRVhTIyOU5iUn+HoUekuZlixFwMhqn2iPHSzdJwU51HCSb4NGPenTlsXUgdI+ZeYRZCs3Gb4oVfLEs4F/ustbfzYyUNdrWRAf3ZyruXV/JALld1H0mB7ypRd81gdllqX+/L4fGeMffRcmIl8H1g6BUjO4G6sL4M4fGJo/K/iNcMH7PJD4+stQkv4vWds65Jdo/ujKwtx8kVwZLlckbk8OQO1x7u2TWE7mzrwR0ZnnGBZV2EPLbnr2ecQy1ssef6Lwjmh/H3iU4MlV8CjDjnpizxiU+ys6HrOj4/H2LDiySS8HrwPKFIUq/ZtXH4bOk1+m7Dt8VR+g/fWx5V+pPXCSFJnf+klfPf/wDAVhmuAjPFDQAAAABJRU5ErkJggg==);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    width: .32rem;
    height: .32rem;
    display: inline-block;
}

.wrap-info-flex{
    display: flex;
    display: -webkit-flex;
    padding-top: .3rem;
    .flex-box {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: block;
        text-align: center;
        position: relative;
    }
    .balance {
        font-size: 28px;
        line-height: 28px;
    }
    .icon-w-info, .icon-w-question {
        vertical-align: middle;
        margin-left: 5px;
    }
    .flex-box+.flex-box:after {
        content: "";
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        height: 300%;
        width: 300%;
        pointer-events: none;
        -webkit-transform: scale(.33333);
        -moz-transform: scale(.33333);
        transform: scale(.33333);
        -webkit-transform-origin: 0 0;
        -moz-transform-origin: 0 0;
        transform-origin: 0 0;
        border-top: 0 solid #5e9fff;
        border-right: 0 solid #5e9fff;
        border-bottom: 0 solid #5e9fff;
        border-left: 1px solid #5e9fff;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        -o-border-radius: 0;
        border-radius: 0;
    }

} 

.icon-w-question {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUxpcf///////////////////////////////////////////////////////////////////////////////////////////////1SsvH4AAAAYdFJOUwDNQKyWJsAFGPTe8eV9R4LHDDgT2VktbAx3QVsAAAElSURBVDjLhVNZloQgDERFkEXc7br/SQdlC23PMz9KCJWqLIxlk46LXaldcCfZ0wZukM3w4etaTgpoxrZflr4dG0BNFcowA11fzn0HzATktNBrDblq2DO/txDbN6dNwEYMOUP8oC0F5uCeoLcfstimMd0JFNYstVG6azMPqCsJRxcdh4GdNcBTRHf9SoOor1fq8J/W4khqYSRzaHL8GICyhzVwPsMYTxpB1gCVRI0+h0AipRD8ZwloIdieKLAh1oV7byax+3dLLf+DjMkWqEfAAXxYCTAkRcxK7u8UhWQUNlXhgsgMCgzNeMkshQoMuhrPkVJf5gTFu0tNmvWwu1m03f7N4cjYhXZXA/MhjNLAVCNHAsrIvQ7t+9i/L8776r0v7//r/wcwSBS+07KOTgAAAABJRU5ErkJggg==);
}
.icon-w-question, .icon-w-question-grey {
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    width: 14px;
    height: 14px;
    display: inline-block;
}

/* 中间  */
.wrap-info-flex.wrap-info-flex-white {
    background-color: #fff;
    color: #3b8aff;
    padding-top: 0;
    line-height: 1;
    padding: .14rem;
}


/* cell */
.list {
    position: relative;
    background-color: #fff;
    overflow: hidden;
}
.margin-tp-md {
    margin-top: 10px;
}

.board:before, .list:before, .otpLine .otp:before, .pop-content:before, .tab:before, .wrap-table:before {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 1px solid #f1f1f1;
    border-right: 0 solid #f1f1f1;
    border-bottom: 0 solid #f1f1f1;
    border-left: 0 solid #f1f1f1;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}

.item {
    padding-left: .15rem;
    padding-right: .15rem;
    position: relative;
    overflow: visible;
    display: block;
    font-size: 16px;
}
.item-md {
    color: #657389;
    height: .5rem;
    line-height: .5rem;
}
.list-icon {
   display: inline-block;
   width: .25rem;
   margin-right: 5px;
   text-align: center;
   height: .5rem;
   line-height: .5rem;
}
.icon-w-extract, .icon-w-mod, .icon-w-money {
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
}

.icon-w-card {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgBAMAAACbaIdJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUxpcWp6jz+E62ZziWZ0iWV0imVziTuK/9lHMdcAAAAGdFJOUwActemntR1kRbgAAABISURBVCjPY2B0TsMAJgIMwmlYgCGDWyADBhBNYTATwBRmTGZIY8AC0qgkXI4F4BYeGS6hm7ASGBIrTMhsHMkHR2LDkTSxJ2QAnR9ccfykM4gAAAAASUVORK5CYII=);
    width: .22rem;
    height: .16rem;
}
.icon-w-extract, .icon-w-money {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAB1UExURUxpcW2Alml1i2d0i2d0i2d1i2d0i2d1i0KS/zuK/zyL/2Z1i2p4jml2jWd2izyL/zyL/zyL/zyL/zyL/2Z1i2d0i2h5i2Z0i2d2i256kGd1ijuL/zyL/0CS/2Z0iz2K/zuK/2Z0izyM/zyN/zyL/2Z0ijuK/xMu8DUAAAAldFJOUwALQsKr6vSCDvg73CM3cue5mddXU9As/I4Xmn3FHFppvn1qJr8EGi1XAAAB/UlEQVQ4y5VV15arMAwUuGADCYSeRqr0/5+4Irt0cu/xPDixEWZmJMsAC+wCKSKtIyGDHfwT/knhBOrkfw3dCQ6ImtaPPS/22ybiqdjePpa81aOaLlUP/pCMNxgo1IEHYPLDO7M2ex9yA+AFGtWKy75GeQTI75YG2HsOcJRY7+exDWIAEF44In2GL2Ne4TPl9y4hQIDYzPZFXQAciJKbGVfNLSE6ABQaJ3v7NRZgUrJnM/+gOVtKDRRYD7xjxRxMRkm41h0mlBlmonpPJEqAlLLrlqPXjNK/kE8uUB+Zb3LdTtU1Yd5Hjb/ZEUwiJBt+S2xoKWQi4qMOlQcXOn+vmDNdwFPYaTzhA3JKeh9kXfXsTr0nCeXw+EwVVnCn22CNFr9/BCv5w43uUKHqNojAWDsaHLDnjHaSiM/ziCUGnMu8c6eHF0VcT54qJ6xT5tGwDxJb9u05eVJ0ZRLgtNae7F7LVgtefdPMN6njWMuZe/Rm1wRTiSGj1+wYaClHdR1elEHM4jR6YGnUV5RlqRE1/xSjQrLgoV4FV3uGUt1YrYI3aABE5Xze01gK3AUMpbqxWglcWlcIhtbd6K+sWyVli0aflFW6N4KHdC8LaSt4KKRliW4ET0rUqfidjpXbgXVqBW5Nxql9uTVGt5br1szdrgm3C8jtanO8NP97Hf8AT00/5WNaZ9YAAAAASUVORK5CYII=);
    width: .22rem;
    height: .22rem;
}
.icon-w-card, .icon-w-list {
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
}

.list-icon i {
    vertical-align: middle;
    margin-top: -3px;
}

.item .el-rt {
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    transform: translateY(-50%);
    right: .15rem;
}
.fz-num {
    font-size: 18px!important;
}
.color-theme {
    color: #3b8aff!important;
}

.icon-arrow-rt {
    display: inline-block;
    font-size: 12px;
    background: url('../assets/rightArrow.png') no-repeat;
    width: .15rem;
    height: .15rem;
    background-size: contain;
    margin-bottom: -0.02rem;
    margin-left: 0.02rem;
}

.icon-w-error, .icon-w-setting {
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
}
.icon-w-setting {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAqCAMAAAD/A0kuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACHUExURUxpcWd2i2Z1i2Z1i2Z0i2d2i2d2jGZ0i2Z1imd1jGCS0ml5jmZ1i2CHvGZ1ijyM/2d0i2d1ijyL/2d1i2x6kjuL/zyL/2d1i2d3jWZ1i2d1i2d1jD2P/2h4jWd0i0GQ/zyL/zuL/2h2jDyL/zuL/zuL/2d1izuL/zyL/z2L/z2M/2Z0ijuK//8VV0UAAAArdFJOUwBWsM/1SDzu/GoGH7sO407B14iBE/OZkDSimlwoKcsVXq4u5LnXdMo3ZnGcjbFqAAACMUlEQVQ4y41V6bqjIAxFBUVrrdatu91v74T3f74JuFGQ+YYfKvEQTk5CIEQfcUCLeJoUNIiJa4QByLHvZ3s1CcJF6Govf70RUFaEVKX8kMv3KxsbU4jkpq30F0XyeZDmCKjFhQFvq/4rV/tD7qlp1XJgBjgFfybEjkc2b+5DaoAp0Go57DXyM0xIkjk0AguMUhyXwd4kpm4KnZ49w4T6OjhXHN6GqYDcldgUCiMlWnyf5lXXP9tuTgF8pYXRScukEf2of2fXdPIU+hmqMyQh+RHitjmdrvjejklCXTNfxV+qYhilaER97VdthdiM7lSplIoR1sGY3JMQVzKteyWj71SimCwK7zyR34rnnOfH5JqQsydLJPvS96X9x5VbXW/IsIISzVKL0zy5ipsuGVDCgfwnmHMDbNBoDDCFtWZoNGeJHiBOkUb2VW2fWVx0/NDD2WGAPvDLYTeZbqIe0H+E+J2RhwvHgxfCkJ1B3JcQzafrNk+hMVZZlhRirnUWQrrnUEiayAeJ4Kr07nILrQo3z1qIRzNreARJ9T5RiiDSE9npClX4c2ccwdJ1UkrrEAYojGNkEBDrXN2XsWfjVPVBOJoMszuK/68m49vty03D7nWFK8DCAvsQjELv2jQI0naUtrpYNEIO0VsW2Wro5cMpTrD1c6sLesi6YGSFPQRoUVBQvYQV+PIWmjbeB+DLCytOpEd5VaFGvF0vx626A7T9TN1EkJ6dN6GXZvm0qZdn6TeDv1A2Pw1CAQ7jAAAAAElFTkSuQmCC);
    width: .22rem;
    height: .21rem;
}
.no-padding{
    padding:0!important;
}
</style>



// WEBPACK FOOTER //
// src/views/WalletCenter.vue